import React from 'react'
import PropTypes from 'prop-types'

const CartDeleteBtn = ({ title, deleteCartProduct }) => (
  <button
    tabIndex='-1'
    className='btn btn-danger'
    type='button'
    onClick={deleteCartProduct}
    >
    <i className='fa fa-fw fa-trash' />{ title }
  </button>
)

CartDeleteBtn.propTypes = {
  title: PropTypes.string.isRequired,
  deleteCartProduct: PropTypes.func.isRequired
}

export default CartDeleteBtn



// WEBPACK FOOTER //
// ./src/molecules/components/CartDeleteBtn.js